import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { RequireOrg } from './components/RequireOrg';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { DashboardPage } from './pages/DashboardPage';
import { GeneratorEditorPage } from './pages/GeneratorEditorPage';
import { LeadsPage } from './pages/LeadsPage';
import { PublicGeneratorPage } from './pages/PublicGeneratorPage';
import { AccountPage } from './pages/AccountPage';
import { DocsPage } from './pages/DocsPage';
import { ApiPage } from './pages/ApiPage';

export default function App() {
    // basename = /app pour que l'app vive sous https://site.com/app/*
    // (la landing statique vit à la racine sur Vercel)
    return (
        <BrowserRouter basename="/app">
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/signup" element={<SignupPage />} />

                    {/* Route publique : accessible sans auth */}
                    <Route path="/g/:orgSlug/:genSlug" element={<PublicGeneratorPage />} />

                    <Route
                        path="/onboarding"
                        element={
                            <ProtectedRoute>
                                <OnboardingPage />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <RequireOrg>
                                    <DashboardPage />
                                </RequireOrg>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/generator/:id/edit"
                        element={
                            <ProtectedRoute>
                                <RequireOrg>
                                    <GeneratorEditorPage />
                                </RequireOrg>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/leads"
                        element={
                            <ProtectedRoute>
                                <RequireOrg>
                                    <LeadsPage />
                                </RequireOrg>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/generator/:id/leads"
                        element={
                            <ProtectedRoute>
                                <RequireOrg>
                                    <LeadsPage />
                                </RequireOrg>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/account"
                        element={
                            <ProtectedRoute>
                                <RequireOrg>
                                    <AccountPage />
                                </RequireOrg>
                            </ProtectedRoute>
                        }
                    />
                    {/* Documentation : publique (SEO + acquisition) */}
                    <Route path="/docs" element={<DocsPage />} />
                    <Route path="/docs/*" element={<DocsPage />} />
                    <Route
                        path="/api"
                        element={
                            <ProtectedRoute>
                                <RequireOrg>
                                    <ApiPage />
                                </RequireOrg>
                            </ProtectedRoute>
                        }
                    />

                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}
